import { Fragment } from 'react';

const ClubAddress = ({ address, activeClubMemberships }) => {
  if (activeClubMemberships) {
    const addressInMemberships = activeClubMemberships.filter(
      (membership) => membership.shipToCustomerAddressId === address.id
    );
    if (addressInMemberships.length > 0) {
      return addressInMemberships.map((clubMembership) => (
        <Fragment key={clubMembership.id}>
          <br />
          <em>({clubMembership.club.title} shipping address)</em>
        </Fragment>
      ));
    }
  }
  return null;
};

export default ClubAddress;
